var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsumedReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67682 20.8411L5.8573 21.2252C4.9958 21.6288 3.99895 21.0136 4 20.079L4.01049 7.14213C4.01049 4.58476 5.46485 3 8.07241 3H15.9445C18.5593 3 19.9811 4.58476 19.9811 7.14213L20 20.0759C20.0011 21.0116 19.0042 21.6278 18.1416 21.2231L17.3285 20.8421C16.8394 20.612 16.2739 20.5956 15.7713 20.7969L13.4565 21.7213C12.5237 22.0931 11.4775 22.0931 10.5446 21.7203L8.23401 20.7969C7.73138 20.5956 7.1658 20.612 6.67682 20.8411Z",
    stroke: "#4546F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.5006C9.25 9.37803 10.0443 8.25 11.2722 8.25H13.6361C14.0503 8.25 14.3861 8.58579 14.3861 9C14.3861 9.41421 14.0503 9.75 13.6361 9.75H11.2722C11.0951 9.75 10.75 9.96503 10.75 10.5006C10.75 11.0346 11.0948 11.2501 11.2722 11.2501H12.7268C13.9551 11.2501 14.75 12.3775 14.75 13.5006C14.75 14.6229 13.9548 15.75 12.7268 15.75H10.3629C9.94866 15.75 9.61287 15.4142 9.61287 15C9.61287 14.5858 9.94866 14.25 10.3629 14.25H12.7268C12.9055 14.25 13.25 14.0341 13.25 13.5006C13.25 12.9656 12.9052 12.7501 12.7268 12.7501H11.2722C10.0446 12.7501 9.25 11.6223 9.25 10.5006Z",
    fill: "#4546F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V15C11.25 14.5858 11.5858 14.25 12 14.25Z",
    fill: "#4546F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V9C12.75 9.41421 12.4142 9.75 12 9.75C11.5858 9.75 11.25 9.41421 11.25 9V8C11.25 7.58579 11.5858 7.25 12 7.25Z",
    fill: "#4546F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumedReceipt);
export default __webpack_public_path__ + "static/media/consumedReceipt.2919d3d2d992d7e62ba9d3372f9d0e83.svg";
export { ForwardRef as ReactComponent };